//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import MobileHeader from "@/components/Mobile/MobileHeader.vue";
import { url } from "vuelidate/lib/validators";

export default {
    name: "SoftwareLicenses",
    components: { AQButton, AQDialog, MobileHeader },
    props: {
        mobile: { type: Boolean, default: false }
    },
    validations: {
        currentLicense: {
            libraryUrl: { url }
        }
    },
    data() {
        return {
            licenses: [],
            viewLicenseDialog: false,
            menuOpened: false,
            currentLicense: {
                libraryName: "",
                licenseName: "",
                libraryUrl: ""
            }
        };
    },
    created() {
        this.actBackendLicenses().then(rsp => {
            this.backendLicensesManipulation(rsp.data);
            this.filterSameNameLicenses();
        });
        this.actFrontendLicenses().then(rsp => {
            this.frontendLicensesManipulation(rsp.data);
            this.filterSameNameLicenses();
        });
    },
    methods: {
        ...mapActions("main", ["actBackendLicenses", "actFrontendLicenses"]),
        openViewDialog(license) {
            this.currentLicense = license;
            this.viewLicenseDialog = true;
        },
        backendLicensesManipulation(data) {
            Object.keys(data).forEach(key => {
                this.licenses.push({
                    libraryName: key,
                    licenseName: data[key].licenses[0].name,
                    libraryUrl: data[key].licenses[0].url
                });
            });
        },
        frontendLicensesManipulation(data) {
            data.data.body.forEach(elem => {
                this.licenses.push({
                    libraryName: elem[0],
                    licenseName: elem[2],
                    libraryUrl: elem[3]
                });
            });
        },
        filterSameNameLicenses() {
            this.licenses = this.licenses.filter((obj, index) => this.licenses.findIndex(item => item.libraryName === obj.libraryName) === index);
        }
    }
};
